import { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { window } from '../../../globals';
import { RouterLink } from '../Link';
import './AnnouncementBanner.less';
import { isEnterpriseTier } from '../../../../shared/subscriptions';

export const NEW_BILLING_PLAN_ANNOUNCEMENT_START_DATE = '2024-07-12';
export const HIDE_ANNOUNCEMENT_AFTER_DATE = '2024-08-12';

/**
 * AnnouncementBanner
 *
 * This component is used to display a general announcement on the FOSSA site.
 * For now, the announcement message is hard-coded and gated behind a feature flag.
 * In the future, we can explore hooking into the API to get the message and possibly re-using the BannerManager.
 */
const AnnouncementBanner = () => {
  // declare show state
  const [isShowing, setShow] = useState(true);
  const announcementStartDate = new Date(NEW_BILLING_PLAN_ANNOUNCEMENT_START_DATE);

  const billingPlan = window.user?.organization?.stripe_plan;
  const isPlanTargetAudience = !isEnterpriseTier(billingPlan);

  let createdDate;
  if (window.user?.organization?.createdAt) {
    createdDate = new Date(window.user.organization.createdAt);
  } else if (window.user?.createdAt) {
    createdDate = new Date(window.user.createdAt);
  }

  const today = new Date();
  const isCurrentDateAfterHideDate = today >= new Date(HIDE_ANNOUNCEMENT_AFTER_DATE);
  const isOrgCreatedBeforeAnnouncementDate = createdDate ? createdDate <= announcementStartDate : false;
  const shouldShowAlert =
    isShowing &&
    !window.on_prem &&
    isPlanTargetAudience &&
    isOrgCreatedBeforeAnnouncementDate &&
    !isCurrentDateAfterHideDate;

  if (!shouldShowAlert) {
    return null;
  }

  return (
    <Alert
      bsStyle="info"
      bsClass="alert alert-general-announcement"
      onDismiss={() => {
        setShow(false);
      }}
    >
      <strong>🎉 New Feature Alert:</strong> FOSSA&apos;s Free and Business Tiers now support Security and Quality
      scanning!{' '}
      <RouterLink to="https://fossa.com/blog/secure-open-source-fossa-upgraded-free-plan/" openInNewTab>
        Learn more
      </RouterLink>
      .
    </Alert>
  );
};

export default AnnouncementBanner;
